export default {
  title: 'Modificadores',
  master_title: 'Modo marca - Modificadores',
  products_creation_disabled:
    'Debido a la integración activa con {{integration}}, no se permite crear nuevos productos. Si necesitas cambiar el menú, realiza los cambios en {{integration}} y sincroniza el menú.',
  labels: {
    select_all: 'Seleccionar todo',
  },
  buttons: {
    add_modifier: 'Añadir modificador',
    delete_selected: 'Eliminar seleccionados',
    refresh: 'Actualizar',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
  },
};
